<div class="d-flex flex-column">
  <h5>Mes informations de facturation</h5>
  <div class="d-block w-100">
    <div class="row">
      <p-input
        [formControl]="this.infosFacturationForm.controls.codeClient"
        [disabled]="true"
        id="codeClient"
        type="text"
        label="Code Client"
        name="codeClient"
        class="col-2"
      ></p-input>
      <p-input
        [formControl]="this.infosFacturationForm.controls.siret"
        [disabled]="true"
        id="siret"
        type="text"
        label="SIRET"
        name="siret"
        class="col-4"
      ></p-input>
      <p-input
        [formControl]="this.infosFacturationForm.controls.raisonSociale"
        [disabled]="true"
        id="raisonSociale"
        type="text"
        label="Raison sociale"
        name="raisonSociale"
        class="col-6"
      ></p-input>
    </div>

    <div class="row">
      <p-input
        [formControl]="this.infosFacturationForm.controls.adresse"
        [disabled]="true"
        id="adresse"
        type="text"
        label="Adresse"
        name="adresse"
        class="col-6"
      ></p-input>
      <p-input
        [formControl]="this.infosFacturationForm.controls.codePostal"
        [disabled]="true"
        id="codePostal"
        type="text"
        label="Code postal"
        name="codePostal"
        class="col-2"
      ></p-input>
      <p-input
        [formControl]="this.infosFacturationForm.controls.ville"
        [disabled]="true"
        id="ville"
        type="text"
        label="Ville"
        name="ville"
        class="col-4"
      ></p-input>
    </div>

    <div class="row">
      <p-input
        [formControl]="this.infosFacturationForm.controls.modePaiement"
        [disabled]="true"
        id="modePaiement"
        type="text"
        label="Mode de paiement"
        name="modePaiement"
        class="col-3"
      ></p-input>
      <p-input
        [formControl]="this.infosFacturationForm.controls.emailIdNot"
        [disabled]="true"
        id="emailIdNot"
        type="email"
        label="Email de contact"
        name="emailIdNot"
        helpText="Pour toute modification de votre email, reportez vous sur votre fiche client Perval (ou votre compte id.not si vous en avez un)."
        class="col-6"
      ></p-input>
      <p-input
        [formControl]="this.infosFacturationForm.controls.telephone"
        [disabled]="true"
        id="telephone"
        type="text"
        label="Téléphone"
        name="telephone"
        class="col-3"
      ></p-input>
    </div>
  </div>

  <p>
    <i-feather name="info" class="text-black-50 mt-2"></i-feather>
    Ces informations ne sont pas correctes ? Contactez notre service client
    ADNOV au 0 800 710 620.
  </p>
</div>

<p-modal
  *ngIf="isModalMailMissingOpen"
  [modalId]="modalId"
  [canClose]="false"
  title="Information"
>
  <div class="d-flex flex-column align-items-center">
    <p>
      Votre adresse email de contact est manquante. Veuillez la renseigner pour
      continuer votre commande.
    </p>
    <div>
      <p-button label="Mettre à jour mon email" routerLink="/profil"></p-button>
    </div>
  </div>
</p-modal>
